<template>
  <div class="container">
    <head-nav-bar
      title="我的账单明细"
      :fixed="true"
      @click-left="onLeftClick"
    />
    <div class="mt-header-nav">
      <cell-box>
        <cell-item label="就诊流水号：" :value="info.billId" />
      </cell-box>
      <cell-box style="padding-bottom: 0.3rem;" :column="2">
        <cell-item label="姓名：" :value="info.patientName" />
        <cell-item label="日期：" :value="info.visitDate" />
        <cell-item label="科室：" :value="info.departmentName" />
        <cell-item label="医生：" :value="info.doctorName" />
      </cell-box>
      <div class="kong"></div>
      <div class="box">
        <DataList :data="list">
          <template v-slot:item="item">
            <van-cell>
              <div slot="title">
                <div>
                  <span>{{ item.obj.chargeItem }}</span>
                </div>
              </div>
              <div class="value">
                <span class="num" v-if="item.obj.count > 0"
                  >{{ item.obj.itemPrice }}×{{ item.obj.count
                  }}{{ item.obj.unit }}</span
                >
                <span class="money">￥{{ item.obj.amount }}</span>
              </div>
            </van-cell>
          </template>
        </DataList>
      </div>
      <div class="kong"></div>
      <div class="footer-actions">
        <van-button
          size="small"
          type="info"
          :loading="loading"
          v-if="info.canPay"
          @click="toPay"
          >支付</van-button
        >
        <van-button
          size="small"
          v-if="info.canRefund"
          type="danger"
          @click="toRefund"
          >退款</van-button
        >
        <van-button size="small" v-if="info.canCancel" @click="cancel"
          >取消订单</van-button
        >
        <!-- <van-button type="primary" size="small" style="margin-left:0.3rem;"
            >订单改签</van-button -->
        >
      </div>
    </div>
    <form ref="form" method="post" name="auto_submit_form" :action="payAction">
      <input
        v-for="item in payParams"
        :key="item.Key"
        type="hidden"
        :name="item.key"
        :value="item.value || ' '"
      />
      <input
        type="submit"
        value="立刻提交"
        style="display:none"
        name="name"
        id="name"
      />
    </form>
    <action-sheet v-model="show" :actions="payMethod" @select="onSelect" />
  </div>
</template>

<script>
import {
  Button,
  Icon,
  NoticeBar,
  Cell,
  Notify,
  ActionSheet,
  Dialog,
} from "vant"
import { CellBox, CellItem } from "@/components/cell"
import DataList from "@/components/DataList"
import wx from "weixin-jsapi"
import urls from "@/api/url"

export default {
  name: "userBillInfo",
  components: {
    ActionSheet,
    DataList,
    CellBox,
    CellItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Cell.name]: Cell,
  },

  data() {
    return {
      show: false,
      loading: false,
      urlQuery: "",
      info: {},
      list: [],
      type: 0,
      payMethod: [],
      payAction: "",
      payParams: [],
    }
  },
  created() {
    this.urlQuery = this.$route.query
    this.type = this.urlQuery.type
    if (this.urlQuery) {
      this.getInfo()
    }
    this.$post("Common_SelectData", { Code: "MobilePayMethodDic" }).then(
      (res) => {
        res.data.MobilePayMethodDic.map((item) => {
          this.payMethod.push({
            name: item.text,
            ...item,
          })
        })
      }
    )
  },
  methods: {
    getInfo() {
      this.$post("Bill_Info", this.urlQuery).then((res) => {
        this.info = res.data
        this.list = res.data.chargeItemList
      })
    },
    toPay() {
      if (this.payMethod.length == 1) {
        this.onSelect(this.payMethod[0])
      } else {
        this.show = true
        return
        //这里做支付处理
      }
      this.loading = true
    },
    onSelect(item) {
      this.show = false
      delete item.id
      this.$post("Pay_Wechat", {
        Id: this.info.billId,
        PayType: "2",
        DoctorId: this.urlQuery.doctorId,
        DepartmentId: this.urlQuery.departmentId,
        VisitDate: this.urlQuery.visitDate,
        DiagnosisCardNo: this.urlQuery.diagnosisCardNo,
        OutTradeNo: Date.now() + "",
        payMethod: item.value,
      }).then((res) => {
        this.loading = false
        this.setWxConfig(res.data)
      })
    },
    setWxConfig(option) {
      const that = this
      if (option.apiUrl) {
        this.payAction = option.apiUrl
        this.payParams = option.params.map((item) => {
          item.value.replace('"', "&quot;")
          return item
        })
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      } else {
        wx.config({
          debug: false, //这里一般在测试阶段先用true，等打包给后台的时候就改回false,
          appId: option.appId,
          timestamp: option.timeStamp,
          nonceStr: option.nonceStr,
          signature: option.paySign,
          jsApiList: ["chooseWXPay"],
        })
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {
              console.log(res, "seccess")
            },
            fail: function(res) {
              console.log(res, "fail")
            },
          })
          that.jsApiCall(option)
        })
      }
    },
    jsApiCall(option) {
      const _this = this
      wx.ready(function() {
        wx.chooseWXPay({
          appId: option.appId,
          timestamp: option.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: option.nonceStr, // 支付签名随机串，不长于 32
          package: option.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: option.paySign, // 支付签名
          success: function() {
            //跳转到支付成功页面有这个页面
            // _this.getInfo();

            Notify({ background: "rgb(7,193,96)", message: "支付成功" })
            _this.$router.push({
              name: "userBill",
            })
          },
          cancel: function(res) {
            console.log(res)
            //取消支付
            // _this.$router.push({
            //   name: "servePreOrderResult",
            //   query: { Id: _this.Id }
            // });
          },
          fail: function(res) {
            console.log(res)
            alert("支付失败，请重试")
          },
        })
      })
    },
    cancel() {},
    toRefund() {
      Dialog.confirm({
        message: "确认退款？",
      })
        .then(() => {
          var sum = 0
          for (let i = 0; i < this.list.length; i++) {
            sum += Number(this.list[i].amount)
          }
          this.$post(this.$config.payUrl + urls.RefundOutpatientFee, {
            billId: this.info.billId,
            recipeIds: this.info.recipeIds.toString(),
            amount: sum,
          }).then(() => {
            this.$toast.success("退款成功！")
            this.$router.push({
              name: "userBillList",
              query: {
                tab: this.type,
              },
            })
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    onLeftClick() {
      if (this.type == 0) {
        this.$post("UpdateOutPatientInfoState", {
          billId: this.info.billId,
        }).then(() => {
          this.$router.push({
            name: "userBillList",
            query: {
              tab: this.type,
            },
          })
        })
      } else {
        this.$router.push({
          name: "userBillList",
          query: {
            tab: this.type,
          },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.result {
  font-size: 0.5rem;
  text-align: center;
  padding: 0.5rem;
  .icon {
    font-size: 0.6rem;
    color: @green;
  }
}
/deep/.title {
  width: auto !important;
}
.money {
  margin-left: 10px;
}
</style>
